import React from "react"

export function canRender(renderable, renderableProps){
  if(typeof renderable === "function"){
    const element = renderable(renderableProps)
    if(React.isValidElement(element)){
      return {
        isRenderable: true,
        element
      }
    }
  } else {
    if(React.isValidElement(renderable)){
      return {
        isRenderable: true,
        element: renderable
      }
    }
  }
  return {
    isRenderable: false
  }
}

export default canRender